import { InfoIcon } from '@/app_components/common/widgets/RatesWidget/InfoIcon';
import { cn } from '@/app_lib/utils/utils';

interface DataPointProps {
  title: string;
  value?: string | number;
  bottomValue?: string;
  tooltip?: string;
  className?: string;
}

export const DataPoint = ({ title, value, bottomValue, tooltip, className }: DataPointProps) => {
  return (
    <div className={cn('md:border-none odd:border-r-2 stroke-helper', className)}>
      <div className='flex items-center md:hidden gap-2'>
        <div className='uppercase typography-sm'>{title}</div>
        {tooltip && <InfoIcon tooltip={tooltip} />}
      </div>
      <div className='typography-level-4 font-semibold pb-1'>{value || ''}</div>
      {bottomValue && <div className='typography-xs'>{bottomValue}</div>}
    </div>
  );
};
